import BillingIcon from 'src/assets/icons/customIcons/page-icons/Billing'
import { useLocale } from 'src/hooks/locale/locale'
import { useTranslatable } from 'src/hooks/locale/utils'
import { useUserState } from 'src/hooks/userState'

import SubPageLayout from 'src/views/includes/SubPageLayout'

export default function StudentBillingLayout(): JSX.Element | null {
  const t = useTranslatable()
  const locale = useLocale()
  const userState = useUserState()

  if (userState.data?.regime.functionalIsLimited) return null

  const subBreadcrumbsItems = [
    { page: `${t('billing:financial_information')}`, path: `/${locale}/student/billing/balance` },
  ]

  return (
    <SubPageLayout
      Icon={BillingIcon}
      title={t('billing:financial_information')}
      subBreadcrubms={subBreadcrumbsItems}
      pages={[
        {
          title: t('billingLayout:balance'),
          link: 'balance',
        },
        {
          title: t('billingLayout:payment_schedule'),
          link: 'schedule',
        },
        {
          title: t('billingLayout:deposits'),
          link: 'deposits',
        },
        {
          title: t('billingLayout:payment_instruction'),
          link: 'instruction',
        },
      ]}
    />
  )
}
